import React, {useEffect, useState} from 'react';
import moment, {Moment} from 'moment';
import DateTime from 'react-datetime';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import {RoadmapItem} from '../Services/RoadmapService';
import {RoadmapGroup} from '../Roadmap';

export type NewRoadmapItem = Omit<RoadmapItem, 'id'>;

interface NewItemProps {
  time: number;
  groupId: number;
  groups: RoadmapGroup[];
  create: (item: NewRoadmapItem) => void;
  close: () => void;
}

const NewItem = ({
  time,
  groupId,
  groups,
  create,
  close,
}: NewItemProps) => {
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [group, setGroup] = useState(0);
  const [groupTitle, setGroupTitle] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [groupOpen, setGroupOpen] = useState(false);

  const toggleGroup = () => {
    setGroupOpen(!groupOpen);
  };

  useEffect(() => {
    setStartDate(moment(time));
    setEndDate(moment(time).add(3, 'month'));
    setGroup(groupId);
    setTitle('');
    setDescription('');
  }, [time, groupId]);

  useEffect(() => {
    const actualGroup = groups.find(g => g.id === group);
    if (actualGroup) {
      setGroupTitle(actualGroup.title);
    }
  }, [group, groups]);

  const save = () => {
    create({
      group,
      title,
      description,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    });
  };

  const descriptionChanged = (e: React.FormEvent<HTMLInputElement>) => {
    setDescription(e.currentTarget.value);
  };

  const titleChanged = (e: React.FormEvent<HTMLInputElement>) => {
    setTitle(e.currentTarget.value);
  };

  const endDateChanged = (date: Moment | string) => {
    if (typeof date === 'string') {
      return;
    }

    setEndDate(date);
  };

  const startDateChanged = (date: Moment | string) => {
    if (typeof date === 'string') {
      return;
    }

    setStartDate(date);
  };

  const groupChanged = (id: number) => {
    setGroup(id);
  };

  return (
    <div className="d-flex flex-column align-items-start h-100">
      <div>
        <h2>Create item</h2>
      </div>
      <div className="flex-grow-1 w-100">
        <div className="form-group row">
          <label className="col-sm-2">Title</label>
          <div className="col-sm-10">
            <input className="form-control" type="text" onChange={titleChanged} value={title} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">Description</label>
          <div className="col-sm-10">
            <input className="form-control" type="text" onChange={descriptionChanged} value={description} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">Start Date</label>
          <div className="col-sm-10">
            <DateTime value={startDate} onChange={startDateChanged} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">End Date</label>
          <div className="col-sm-10">
            <DateTime value={endDate} onChange={endDateChanged} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">Group</label>
          <div className="col-sm-10">
            <Dropdown isOpen={groupOpen} toggle={toggleGroup}>
              <DropdownToggle className="dropdown-toggle">{groupTitle}</DropdownToggle>
              <DropdownMenu>
                {groups.map(g => (
                  <DropdownItem
                    key={g.id}
                    onClick={() => groupChanged(g.id)}
                  >
                    {g.title}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="align-self-end">
        <button className="btn btn-primary m-1" onClick={save}>Create</button>
        <button className="btn btn-secondary m-1" onClick={close}>Cancel</button>
      </div>
    </div>
  );
};

export default NewItem;
